
<table id="add-groupKey-table">
    <col width="15%">    
    <col width="65">
    <col width="20%">
    <tbody>
        <tr>
            <th colspan="3">
                <div style="text-align: center;">
                    Add Group Key
                </div>               
            </th>
        </tr>
        <tr>
            <td>Group Key</td>
            <td>Name</td>
            <td></td>
        </tr>
        <tr>
            <td>
                <input type="text" 
                        size="8"                        
                        tabindex="-1"                      
                        id="newGroupKey"
                        #newGroupKey
                        (input)="fieldChanged(newGroupKey)"
                        />
            </td>
            <td>
                <input type="text" 
                        size="8"                        
                        tabindex="-1" 
                        #newGroupKeyName
                        id="newGroupKeyName"
                        (input)="fieldChanged(newGroupKeyName)"
                        />
            </td>
            <td style="text-align: center;">
                <div class="action-buttons" ngbTooltip="Save New Member">
                    <a (click)="addNewGroupKey()">
                        <i class="fa fa-save" style="color: blue"></i>                        
                    </a>
                </div>
                <div class="action-buttons" ngbTooltip="Cancel">
                    <a (click)="canceladdNewGroupKey()">
                        <i class="fa fa-minus" style="color: red"></i>                        
                    </a>
                </div>
            </td>
        </tr>
    </tbody>
</table>
<p style="color:red; font-size: smaller;">{{errormessage}}</p>
